ux-popover-panel-arrow {
  pointer-events: none;
}

.ux-popover-panel-arrow {
  border: var(--ux-popover-panel-arrow-length) solid transparent;
  height: 0;
  position: absolute;
  width: 0;

  [data-popover-placement^="bottom"] & {
    border-top-width: 0;
    left: var(--ux-popover-panel-arrow-inset);
    top: calc(#{var(--ux-popover-panel-arrow-length)} * -1);

    &.ux-popover-panel-arrow__border {
      border-bottom-color: var(--ux-popover-panel-border-color);
    }

    &.ux-popover-panel-arrow__fill {
      border-bottom-color: var(--ux-popover-panel-bg-color);
      transform: translateY(calc(#{var(--ux-popover-panel-border-width)} * 1.414));
    }
  }

  [data-popover-placement^="top"] & {
    border-bottom-width: 0;
    bottom: calc(#{var(--ux-popover-panel-arrow-length)} * -1);
    left: var(--ux-popover-panel-arrow-inset);

    &.ux-popover-panel-arrow__border {
      border-top-color: var(--ux-popover-panel-border-color);
    }

    &.ux-popover-panel-arrow__fill {
      border-top-color: var(--ux-popover-panel-bg-color);
      transform: translateY(calc(#{var(--ux-popover-panel-border-width)} * -1.414));
    }
  }

  [data-popover-placement="top"] &,
  [data-popover-placement="bottom"] & {
    left: 50%;
    margin-left: calc(#{var(--ux-popover-panel-arrow-length)} * -1);
  }

  [data-popover-placement="top-end"] &,
  [data-popover-placement="bottom-end"] & {
    left: auto;
    right: var(--ux-popover-panel-arrow-inset);
  }

  [data-popover-placement^="right"] & {
    border-left-width: 0;
    left: calc(#{var(--ux-popover-panel-arrow-length)} * -1);
    top: var(--ux-popover-panel-arrow-inset);

    &.ux-popover-panel-arrow__border {
      border-right-color: var(--ux-popover-panel-border-color);
    }

    &.ux-popover-panel-arrow__fill {
      border-right-color: var(--ux-popover-panel-bg-color);
      transform: translateX(calc(#{var(--ux-popover-panel-border-width)} * 1.414));
    }
  }

  [data-popover-placement^="left"] & {
    border-right-width: 0;
    right: calc(#{var(--ux-popover-panel-arrow-length)} * -1);
    top: var(--ux-popover-panel-arrow-inset);

    &.ux-popover-panel-arrow__border {
      border-left-color: var(--ux-popover-panel-border-color);
    }

    &.ux-popover-panel-arrow__fill {
      border-left-color: var(--ux-popover-panel-bg-color);
      transform: translateX(calc(#{var(--ux-popover-panel-border-width)} * -1.414));
    }
  }

  [data-popover-placement="right"] &,
  [data-popover-placement="left"] & {
    margin-top: calc(#{var(--ux-popover-panel-arrow-length)} * -1);
    top: 50%;
  }

  [data-popover-placement="left-end"] &,
  [data-popover-placement="right-end"] & {
    bottom: var(--ux-popover-panel-arrow-inset);
    top: auto;
  }
}
